import { render, staticRenderFns } from "./DeviceAttendances.vue?vue&type=template&id=1638a074"
import script from "./DeviceAttendances.vue?vue&type=script&lang=js"
export * from "./DeviceAttendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports